/*
 * piner cart drawer — opening and closing only.
 *
 * Everything that changes the cart (quantity, removal, stock errors, the
 * Section Rendering API round-trip) belongs to Fabric's cart-items-component;
 * this file deliberately stays out of that. It only:
 *   - opens the drawer from the header's Bag link and after Add to Bag
 *   - keeps the header's bag count in step with the drawer's own count
 * Self-contained: no imports, load with a plain deferred <script>.
 */
(function pinerCart() {
  var OPEN_CLASS = 'pcart-open';

  function drawer() {
    return document.querySelector('[data-pcart]');
  }

  function open() {
    if (!drawer()) return false;
    document.body.classList.add(OPEN_CLASS);
    return true;
  }

  function close() {
    document.body.classList.remove(OPEN_CLASS);
  }

  /* The drawer carries the authoritative count for the cart component; the
     header sits in a different section, so it is told separately. */
  function syncBagCount() {
    var source = document.querySelector('[data-pcart] [ref="cartItemCount"]');
    if (!source) return;
    var count = source.textContent.trim();
    document.querySelectorAll('[data-bag-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-pcart-close]')) {
      close();
      return;
    }

    if (event.target.closest('[data-pcart-dim]')) {
      close();
      return;
    }

    // The Bag link still points at /cart, so it keeps working without JS.
    var bagLink = event.target.closest('[data-bag-link]');
    if (bagLink) {
      if (open()) event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  // Fabric broadcasts this after every cart change it makes.
  document.addEventListener('cart:update', function () {
    // The section has just been morphed in, so read the fresh count.
    window.setTimeout(syncBagCount, 0);
  });

  // Used by piner-product.js once an Add to Bag succeeds.
  window.pinerCart = {
    open: open,
    close: close,
    syncBagCount: syncBagCount,

    /* Swaps in freshly rendered drawer markup returned by the Section
       Rendering API. Anything falsy means the render failed — the API reports
       that as null with a 200, so the old markup is simply kept. */
    replace: function (html) {
      if (!html) return false;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.querySelector('[data-pcart]');
      var current = drawer();
      if (!next || !current) return false;

      current.replaceWith(next);
      syncBagCount();
      return true;
    },
  };
})();
